module.exports = __webpack_public_path__ + "d122dda52034e6ff4d2508f2322179c5.png";